( function( $, document, window ) {
	'use strict';

	$( function() {
		$( '.js-case-study' ).each( function( index, element ) {
			const $this = $( this );
			$this.find( '.js-image-gallery-thumb-carousel' ).addClass( 'image-gallery-thumb-carousel-instance-' + index );
			$this.find( '.js-image-gallery-carousel' ).addClass( 'image-gallery-carousel-instance-' + index );

			const thumbSwiper = new Swiper( '.image-gallery-thumb-carousel-instance-' + index, {
				direction: 'horizontal',
				slidesPerView: 'auto',
				spaceBetween: 10,
				loop: false,
			} );

			const imageSwiper = new Swiper( '.image-gallery-carousel-instance-' + index, {
				direction: 'horizontal',
				slidesPerView: 'auto',
				spaceBetween: 20,
				loop: false,
				autoHeight: true,
				thumbs: {
					swiper: thumbSwiper,
				},
			} );
		} );
	} );
} )( jQuery, document, window );
